/**
 * format.ts — Small display helpers shared by the views.
 *
 * Nothing fancy, just keeps the JSX-ish template strings readable.
 */

import type { ProblemaFondamentale } from '@/data/schema';

/**
 * Format a lifespan like "-625 / -546" into "625 a.C. – 546 a.C.",
 * or "1724 / 1804" into "1724 – 1804". Mixed BC/AD handled.
 */
export function formatLifespan(born: number, died: number): string {
  return `${formatYear(born)} – ${formatYear(died)}`;
}

export function formatYear(year: number): string {
  if (year < 0) return `${Math.abs(year)} a.C.`;
  return String(year);
}

const PROBLEMA_LABELS: Record<ProblemaFondamentale, string> = {
  ontologia: 'Ontologia',
  'etica-felicita': 'Etica e felicità',
  'filosofia-religioni': 'Filosofia delle religioni',
  'scienza-moderna': 'Scienza moderna',
  conoscenza: 'Conoscenza',
  bellezza: 'Bellezza',
  'liberta-potere': 'Libertà e potere',
};

export function problemaLabel(p: ProblemaFondamentale): string {
  return PROBLEMA_LABELS[p] ?? p;
}
